/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GrowthHistoryDto } from '../../models/growth-history-dto';
import { GrowthHistoryUpdateDto } from '../../models/growth-history-update-dto';

export interface GrowthHistoryControllerUpdate$Params {
  id: string;
      body: GrowthHistoryUpdateDto
}

export function growthHistoryControllerUpdate(http: HttpClient, rootUrl: string, params: GrowthHistoryControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<GrowthHistoryDto>> {
  const rb = new RequestBuilder(rootUrl, growthHistoryControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GrowthHistoryDto>;
    })
  );
}

growthHistoryControllerUpdate.PATH = '/api/growth-history/{id}';
